import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'

import GA4 from 'helpers/ga4'

import Resource from 'types/Resource'

import { color } from 'styles/colors'

type Props = {
  video: Resource
}

const WistiaVideoRow = ({ video }: Props) => {
  const onClickVideoLink = (videoName) => {
    GA4.sendEvent({
      category: 'Help Videos',
      action: 'Click video link',
      label: videoName
    })
  }

  if (video == null) {
    return <></>
  }

  return (
    <S.TableRow key={video.name}>
      <S.NameThumbnailCell>
        <a
          href={video.url}
          onClick={() => {
            onClickVideoLink(video.name)
          }}
          target="_blank"
          rel="noreferrer"
        >
          <S.ThumbnailImage
            src={video.thumbnail}
            alt={`${video.name} help video thumbnail`}
          />
        </a>

        <S.NameCell>
          <a
            href={video.url}
            onClick={() => {
              onClickVideoLink(video.name)
            }}
            target="_blank"
            rel="noreferrer"
          >
            {video.name}
          </a>
        </S.NameCell>
      </S.NameThumbnailCell>

      <S.DescriptionCell>
        {video.description}
        <br />
        <i>{video.duration} minutes</i>
      </S.DescriptionCell>
      <S.DateCell>{video.wistiaUpdatedAt}</S.DateCell>
    </S.TableRow>
  )
}

export default WistiaVideoRow

const cellStyle = css`
  padding: 15px;
`

const S = {
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 25%;
  `,
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 2;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-basis: 50%;
  `,
  NameThumbnailCell: styled(Table.Cell)`
    align-items: center;
    flex-basis: 25%;
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
    border-bottom: 1px solid ${color('wistiaVideoTableRowBorder')};
  `,
  ThumbnailImage: styled.img`
    ${cellStyle}
    max-height: 80px;
  `
}
